export const initialData = {
    regulationName: "",
    federalState: "",
    note: "",
}

export const initalAllRentsInputs = {
    number_of_tenant: "",
    abstract_allowed_size: "",
    net_rent: "",
    gross_base_rent: "",
}

export const initalAllMaintenanceInputs = {
    number_of_tenant: "",
    size: "",
    avg_cost: "",
    gross_cost: "",
}

export const initalAllHeatingCostsInputs = {
    size_from: "",
    size_to: "",
    cost_oil: "",
    cost_gas: "",
    cost_electricity: "",
}

export const initalAllHeatingDeductionCostsInputs = {
    number_of_tenant: "",
    centralized_deduction: "",
}